import React from 'react';
import './ChatTabs.css';

const ChatTabs = ({ currentTab, tabCounts, onTabChange, tabTypes }) => {
  const tabs = [
    {
      id: tabTypes.GENERAL,
      label: 'General',
      icon: '💬',
      description: 'All messages'
    },
    {
      id: tabTypes.USER_SPEECH,
      label: 'User Speech',
      icon: '👤',
      description: 'User voice input'
    },
    {
      id: tabTypes.AI_SPEECH,
      label: 'AI Speech',
      icon: '🤖',
      description: 'AI voice responses'
    },
    {
      id: tabTypes.AI_INTENT,
      label: 'AI Intents',
      icon: '🎯',
      description: 'AI action intents'
    },
    {
      id: tabTypes.SYSTEM,
      label: 'System',
      icon: '⚙️',
      description: 'System messages'
    }
  ];

  return (
    <div className="chat-tabs">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`tab-button ${currentTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabChange(tab.id)}
          title={tab.description}
        >
          <span className="tab-icon">{tab.icon}</span>
          <span className="tab-label">{tab.label}</span>
          {tabCounts[tab.id] > 0 && (
            <span className="tab-count">{tabCounts[tab.id]}</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default ChatTabs; 